module.exports = __webpack_public_path__ + "img/home.0a4064c2.gif";